import api from "../../services/reportDashboardItem";
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types("report_dashboard_item");
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({}, "Report Dashboard Item");
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations,
	};
}
